import { useEffect, type ReactNode } from "react";
import { Spinner } from "@heroui/react";
import { loadSession, useAuth } from "@/lib/auth";
import { LoginPage } from "./LoginPage";

/** The app only once signed in; the sign-in page otherwise. */
export function AuthGate({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  useEffect(() => {
    void loadSession();
  }, []);

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" aria-busy="true" aria-label="Loading">
        <Spinner size="md" />
      </div>
    );
  }
  if (status !== "signed-in") return <LoginPage />;
  return <>{children}</>;
}
